'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _index = require('../../../utils/index.js');

var _index2 = _interopRequireDefault(_index);

var _itemActions = require('@wix/photography-client-lib/dist/src/item/itemActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Share = function (_React$Component) {
  (0, _inherits3.default)(Share, _React$Component);

  function Share(props) {
    (0, _classCallCheck3.default)(this, Share);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Share.__proto__ || (0, _getPrototypeOf2.default)(Share)).call(this, props));

    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.getShareArr = _this.getShareArr.bind(_this);
    _this.buttons = [];
    _this.shareArr = _this.getShareArr(_this.props.type);
    _this.state = {
      showShare: false,
      focusedShareIcon: 0
    };

    return _this;
  }

  (0, _createClass3.default)(Share, [{
    key: 'getShareArr',
    value: function getShareArr(type) {
      return type === 'text' ? ['facebook', 'twitter', 'tumblr', 'email'] : ['facebook', 'twitter', 'pinterest', 'tumblr', 'email'];
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e, type) {
      if (this.state.showShare) {
        switch (e.keyCode || e.charCode) {
          case 38: //up
          case 37: //left
          case 33:
            //page up
            e.preventDefault();
            e.stopPropagation();
            _index2.default.setStateAndLog(this, 'Share Keypress', {
              focusedShareIcon: Math.max(1, this.state.focusedShareIcon - 1)
            });
            return false;
          case 39: //right
          case 40: //down
          case 34:
            //page down
            e.preventDefault();
            e.stopPropagation();
            _index2.default.setStateAndLog(this, 'Share Keypress', {
              focusedShareIcon: Math.min(type === 'text' ? 4 : 5, this.state.focusedShareIcon + 1)
            });
            return false;
          case 9: //tab
          case 27:
            //esc
            e.preventDefault();
            e.stopPropagation();
            this.props.actions.toggleShare(e, false);
            _index2.default.setStateAndLog(this, 'Share Keypress', {
              showShare: false,
              focusedShareIcon: 0
            });
            return false;

        }
      }

      switch (e.keyCode || e.charCode) {
        case 32: //space
        case 13:
          //enter
          e.preventDefault();
          e.stopPropagation();
          if (this.state.showShare) {
            _itemActions.itemActions.share(this.shareArr[this.state.focusedShareIcon - 1], this.props, 'gallery');
            this.props.actions.toggleShare(e, false);
            _index2.default.setStateAndLog(this, 'Share Keypress', {
              showShare: false,
              focusedShareIcon: 0
            });
          } else {
            this.props.actions.toggleShare(e, true);
            _index2.default.setStateAndLog(this, 'Share Keypress', {
              showShare: true,
              focusedShareIcon: 1
            });
          }

          return false;
      }

      return true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.showShare && !this.state.showShare) {
        _index2.default.setStateAndLog(this, 'props.showShare is true', {
          showShare: true
        });
      } else if (!this.props.showShare && this.state.showShare) {
        _index2.default.setStateAndLog(this, 'props.showShare is false', {
          showShare: false
        });
      }
      try {
        if (_index2.default.isSite() && !_index2.default.isMobile() && window.document && window.document.activeElement && window.document.activeElement.className) {
          var activeElement = window.document.activeElement;
          var isShareItemInFocus = function isShareItemInFocus() {
            return String(activeElement.className).indexOf('network-') >= 0;
          };

          if (!this.state.showShare && isShareItemInFocus()) {
            this.socialShareBox.focus();
            return;
          }
        }
        var focusedButton = this.state.focusedShareIcon;
        if (focusedButton > 0) {
          this.buttons[focusedButton - 1].focus();
        }
      } catch (e) {
        console.warn('Cannot focus on share icon', this.props.focus, e);
      }
    }
  }, {
    key: 'getShareItem',
    value: function getShareItem(network, idx) {
      var _this2 = this;

      var allProps = this.props.allProps;

      var shareIconsNumber = this.shareArr.length;
      return _react2.default.createElement('button', {
        className: 'block-fullscreen has-custom-focus network-' + (idx + 1) + ' progallery-svg-font-icons-' + network + (_index2.default.isSite() ? '' : ' inactive '),
        style: {
          top: this.props.isVerticalContainer ? 'calc(100% / 6 * ' + (idx + 1) + ' + -10px ' + (shareIconsNumber === 4 ? '+ 100% / 12' : '') + ')' : '',
          left: this.props.isVerticalContainer ? '' : 'calc(100% / 6 * ' + (idx + 1) + ' + -10px ' + (shareIconsNumber === 4 ? '+ 100% / 12' : '') + ')'
        },
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          _itemActions.itemActions.share(network, allProps, 'gallery');
        },
        'data-hook': network + '-share-button',
        ref: function ref(button) {
          return _this2.buttons[idx] = button;
        },
        title: 'Share on ' + network,
        'aria-label': 'Share on ' + network + ', ' + (idx + 1) + ' of ' + this.shareArr.length,
        'aria-live': 'assertive',
        role: 'button',
        tabIndex: -1,
        key: network + '-share-icon' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          styleParams = _props.styleParams,
          id = _props.id,
          isVerticalContainer = _props.isVerticalContainer,
          actions = _props.actions,
          style = _props.style,
          type = _props.type;

      if (styleParams.allowSocial) {
        var minDimension = 200;
        return _react2.default.createElement(
          'div',
          {
            'data-hook': 'social-share-box',
            className: 'block-fullscreen gallery-item-social-share-box ' + (this.props.showShare ? ' opened ' : ' hidden ') + (this.state.showShare ? ' hovered ' : '') + (isVerticalContainer ? ' vertical-item ' : ''),
            ref: function ref(e) {
              return _this3.socialShareBox = e;
            },
            onClick: function onClick(e) {
              return actions.toggleShare(e, false);
            },
            onMouseOut: function onMouseOut(e) {
              return actions.toggleShare(e, false);
            },
            style: {
              transform: isVerticalContainer ? 'translateY(-50%) ' + (style.height > minDimension ? '' : 'scale(' + style.height / minDimension + ')') : 'translateX(-50%) ' + (style.width > minDimension ? '' : 'scale(' + style.width / minDimension + ')')
            },
            tabIndex: styleParams.isSlideshow && this.props.currentIdx === this.props.idx ? 0 : -1,
            onKeyDown: function onKeyDown(e) {
              return _this3.handleKeyDown(e, type);
            },
            'aria-label': 'Share',
            role: 'button',
            key: 'item-social-share-container-' + id
          },
          _lodash2.default.map(this.shareArr, function (network, i) {
            return _this3.getShareItem(network, i);
          })
        );
      }
      return false;
    }
  }]);
  return Share;
}(_react2.default.Component);

exports.default = Share;